export default class LaneItemsClickToCenter {
	/**
	 * Enables click-to-center behavior on lane items.
	 *
	 * @property {import('vue').Component} component - The Vue component instance.
	 * @property {{element: HTMLElement, handler: Function}[]} itemClickHandlers - Array of elements and their click handlers.
	 * @method bindItemClickEvents - Attaches click handlers to lane children.
	 * @method onItemClick - Updates active index and scrolls to center if needed.
	 * @method scrollToActiveItem - Calculates and animates scroll to bring active item into view.
	 * @method destroy - Cleans up all event listeners.
	 */
	constructor(component) {
		this.component = component;
		this.itemClickHandlers = [];
		this.bindItemClickEvents();
	}

	bindItemClickEvents() {
		const { childs } = this.component;
		childs.forEach((child, index) => {
			const handler = (e) => this.onItemClick(e, index);
			child.addEventListener('click', handler);
			this.itemClickHandlers.push({ element: child, handler });
		});
	}

	onItemClick(e, index) {
		if (index !== this.component.activeItemManager.currentActiveIndex) {
			this.component.activeItemManager.currentActiveIndex = index;
			this.scrollToActiveItem();
		}
	}

	scrollToActiveItem() {
		const activeItem = this.component.childs[this.component.activeItemManager.currentActiveIndex];
		const itemOffset = activeItem.offsetLeft;
		const itemWidth = activeItem.offsetWidth;

		let scrollPosition;

		if (this.component.viewportActiveItemTrigger === 'center') {
			const laneCenter = this.component.lane.clientWidth / 2;
			scrollPosition = itemOffset - laneCenter + itemWidth / 2;
		} else {
			scrollPosition = itemOffset;
		}

		const maxScrollLeft =
			this.component.lane.scrollWidth - this.component.lane.clientWidth;
		scrollPosition = Math.max(0, Math.min(scrollPosition, maxScrollLeft));
		this.component.scrollTo(scrollPosition);
	}

	destroy() {
		this.itemClickHandlers.forEach(({ element, handler }) => {
			element.removeEventListener('click', handler);
		});
		this.itemClickHandlers = [];
	}
}
